import { ChangeDetectionStrategy, Component, input, model, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "app-cerrix-radio",
    imports: [],
    templateUrl: "./cerrix-radio.component.html",
    styleUrl: "./cerrix-radio.component.scss",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CerrixRadioComponent {
    readonly disabled = input<boolean>(false);
    readonly required = input<boolean>(false);

    /** Radios sharing a name form one native group: picking one unchecks the rest. */
    readonly name = input<string>("");

    readonly value = model<boolean>(false);

    // A radio only ever reports being picked — clearing it is the group owner's job,
    // which is what makes exactly one option selectable.
    protected select(): void {
        this.value.set(true);
    }
}
